import { render } from 'solid-js/web';
import Entry from './Entry';
import * as Sentry from '@sentry/browser';
import { ENV } from './env';

if (ENV.VITE_DSN)
  Sentry.init({
    dsn: ENV.VITE_DSN,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    tracesSampleRate: 0.2,
    environment: import.meta.env.MODE,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });

render(() => <Entry />, document.getElementById('root') as HTMLElement);
